import styled from '@emotion/styled';

const SocialButtonWrapper = styled.div({
  display: 'flex',
  margin: 'auto 0',
});

export default SocialButtonWrapper;
